<template>
  <div class="row">
    <div v-if="sale" class="col-md-12">
      <div class="card">
        <h2 class="card-header">Sale details</h2>
        <div class="card-body">
          <h5 class="card-title">{{ sale.name }}</h5>
          <h6 class="card-subtitle mb-4 text-muted">
            Sale ID:
            <code>{{ sale.id }}</code>
          </h6>

          <div class="row">
            <div class="col-md-6">
              <table class="table">
                <tbody>
                  <tr>
                    <th>Amount</th>
                    <td>{{ sale.amount | money(sale.currency) }}</td>
                  </tr>
                  <tr>
                    <th>PAN</th>
                    <td>**** **** **** {{ sale.panLastFour }}</td>
                  </tr>
                  <tr>
                    <th>Card scheme</th>
                    <td>{{ sale.cardScheme | humanize }}</td>
                  </tr>
                  <tr>
                    <th>Card issuing country</th>
                    <td>
                      {{ sale.cardCountry }}
                      <flag :iso="sale.cardCountry.toLowerCase()"/>
                    </td>
                  </tr>
                  <tr>
                    <th>Card type</th>
                    <td>{{ sale.cardAudience | humanize }} {{ sale.cardType | humanize }}</td>
                  </tr>
                  <tr>
                    <th>Transaction date</th>
                    <td>{{ sale.createdAt | moment('YYYY-MM-DD HH:mm A') }}</td>
                  </tr>
                  <tr>
                    <th>Driver</th>
                    <td>
                      <router-link :to="`/account/drivers/${sale.driverId}`">{{ sale.driver.name }}</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="loading" class="spinner-container">
        <double-bounce size="60px"></double-bounce>
      </div>
    </div>
  </div>
</template>
  
<script>
import { DoubleBounce } from "vue-loading-spinner";

export default {
  name: "SalePage",
  components: {
    DoubleBounce
  },
  data() {
    return {
      error: null,
      loading: null,
      sale: null
    };
  },
  props: ["saleId"],
  beforeMount() {
    this.loading = true;
    this.axios
      .get(`/v1/sales/${this.saleId}?_expand=driver`)
      .then(response => {
        this.loading = false;
        this.sale = response.data;
      })
      .catch(error => {
        this.loading = false;
        this.error = "Failed to load sale";
      });
  }
};
</script>
